module.exports = __webpack_public_path__ + "static/media/vehicle15.7fc8c7a0.svg";